import React from 'react'
import { Link } from 'react-router-dom'

const Header = ({path, color}) => {
  return (
   <>
       <section className="relative bg-white py-20 sm:pt-10">
          <img
            className="absolute bg-center inset-0 object-[75%] sm:object-[25%] object-cover w-full h-full opacity-100 sm:opacity-100"
            src={path}
            alt="The thoughts I have, the music I hear."
          />
                    <div className="hidden sm:block sm:inset-0 sm:absolute"></div>

<div className="relative max-w-screen-xl px-4 mx-auto lg:h-56 lg:items-center">
<header className="text-white body-font">
  <div className="container mx-auto flex flex-wrap p-5 flex-col md:flex-row items-center">
    <Link to="/" className={`flex title-font font-medium items-center text-${color} hover:text-green-600 mb-4 md:mb-0`}>
      <span className="ml-3 text-xl">Home</span>
    </Link>
    <nav className={`md:ml-auto md:mr-auto flex flex-wrap items-center text-${color} justify-center`}>
      <Link to="/blogs/quotes" className="mr-5 hover:text-blue-600">Quotes</Link>
      <Link to="/blogs/survival-skills" className="mr-5 hover:text-blue-600">Survival skills</Link>
      <Link to="/blogs/nutrition" className="mr-5 hover:text-blue-600">Nutrition</Link>
      <Link to="/blogs/health" className="mr-5 hover:text-blue-600">Health</Link>
      <Link to="/blogs/general-life" className="mr-5 hover:text-blue-600">General</Link>
      <Link to="/blogs/religion" className="mr-5 hover:text-blue-600">Religion</Link>

    </nav>
    <Link to="/podcast" className={`mr-5 text-${color} hover:text-blue-600`}>Podcast</Link>
    <Link to="/about" className={`mr-5 text-${color} hover:text-blue-600`}>About</Link>


  </div>
</header>
</div>
</section>




   </>
  )
}

export default Header